import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Reveal } from '../Reveal';
import { NEXT_STEPS } from '../../data/content';
export function NextCollection({
  onCta
}: {
  onCta: () => void;
}) {
  return <section className="w-full bg-cream-deep px-5 py-14 sm:py-20" data-id="element-145" data-mp="j2iv0k8vczzp">
      <div className="mx-auto grid max-w-5xl gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-146" data-mp="e4pp7sbha7zy">
        <Reveal data-id="element-147" data-mp="96o6j8hysap0">
          <h2 className="font-display text-[34px] leading-tight text-cocoa sm:text-5xl" data-id="element-148" data-mp="977ebwdwhipb">
            Tu próxima colección puede <span className="italic text-terra" data-id="element-149" data-mp="539hjsc1sjzf">empezar hoy</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-cocoa-soft" data-id="element-150" data-mp="6iz4ycrtcau">
            No necesitás tener 20 modelos terminados.
          </p>

          <div className="mt-10 border-t border-sand pt-6" data-id="element-151" data-mp="3redlx0m7hgbc">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-terra" data-id="element-152" data-mp="1uifx7a5pxgev">Megapack Bolsos Crochet Pro</p>
            <p className="mt-2 font-display text-3xl leading-tight text-cocoa" data-id="element-153" data-mp="1pil4d12dugr6">
              De hilo a bolso.
              <br data-id="element-154" data-mp="10sfdybhalwey" />
              De hobby a oportunidad.
            </p>
            <CtaButton className="mt-6 w-full sm:w-auto" onClick={onCta} data-id="element-155" data-mp="14t7mf2icbxa6">
              Quiero acceder al Megapack <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-156" data-mp="qtptqc1xbzvj" />
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-cocoa-dim" data-id="element-157" data-mp="vr82o2fxyf3j">
              Acceso inmediato · Pago seguro · Garantía de 7 días
            </p>
          </div>
        </Reveal>

        <Reveal delay={80} data-id="element-158" data-mp="1of41pdszgj3h">
          <ol className="relative space-y-0" data-id="element-159" data-mp="1ohgdtac27z8m">
            {NEXT_STEPS.map((step, index) => {
            const isLast = index === NEXT_STEPS.length - 1;
            return <li key={step} className="relative flex gap-4 pb-5 last:pb-0" data-id="element-160" data-mp="1eoj0rjpu72he" data-mpi={index}>
                  {!isLast && <span className="absolute left-[11px] top-7 h-[calc(100%-20px)] w-px bg-sand" aria-hidden="true" data-id="element-161" data-mp="22emu8y9b9luo" />}
                  <span className={`relative mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-[11px] font-extrabold ${isLast ? 'bg-terra text-cream' : 'border border-sand bg-cream-card text-cocoa-dim'}`} aria-hidden="true" data-id="element-162" data-mp="277fzdn8oyw7a">
                    {index + 1}
                  </span>
                  <span className={`font-display text-xl leading-snug sm:text-2xl ${isLast ? 'italic text-terra' : 'text-cocoa'}`} data-id="element-163" data-mp="2760or9hyi66i">
                    {step}
                  </span>
                </li>;
          })}
          </ol>
        </Reveal>
      </div>
    </section>;
}